import React, { useMemo } from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd';
import { useSelector } from 'react-redux';
import { updateThemeVariables } from '../store/slice/themeSlice';
import tinycolor from 'tinycolor2';

const mapToAntdTheme = (customTheme: Record<string, string>) => {
  if (!customTheme) return {};

  const {
    primary,
    primaryText,
    secondary,
    secondaryText,
    background,
    text,
    surface,
    sidebarBackground,
  } = customTheme;

  return {
    token: {
      colorPrimary: primary,
      colorBgBase: background,
      colorTextHeading: text,
      colorBgContainer: surface,
      boxShadow: 'none',
    },
    components: {
      Layout: {
        colorBgHeader: sidebarBackground,
        colorBgBody: background,
      },
      Button: {
        colorPrimary: primary,
        colorPrimaryHover: tinycolor(primary).lighten(10).toString(),
        colorPrimaryActive: tinycolor(primary).darken(10).toString(),
        primaryColor: primaryText,
        colorText: primaryText,
        defaultShadow: 'none',
        primaryShadow: 'none',
      },
      Switch: {
        colorPrimary: primary,
        colorPrimaryHover: tinycolor(primary).lighten(10).toString(),
      },
      Divider: {
        colorSplit: tinycolor(surface).darken(10).toString(),
      }
    }
  };
};

const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const { theme } = useSelector((state: any) => state.theme);
  const antdTheme = useMemo(() => mapToAntdTheme(theme), [theme]);
  const hasTheme = useMemo(() => Object.keys(theme || {}).length > 0, [theme]);

  React.useEffect(() => {
    if (theme) {
      updateThemeVariables(theme, 'apply');
    }
  }, [theme]);

 return hasTheme ? (
    <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>
  ) : (
    <>{children}</>
  );
};

export default ThemeProvider;
